import { type RefObject, useEffect, useRef, useState } from "react";

interface Rect extends Omit<DOMRect, "toJson"> {
  /** This is an Integer, use Math.round() with other values to compare. */
  scrollWidth: number;
  /** This is an Integer, use Math.round() with other values to compare. */
  scrollHeight: number;
  // rect: DOMRect;
  widthOverflow: boolean;
}

const useResizeObserver = (ref: RefObject<Element>): Rect | undefined => {
  const [boxSize, setBoxSize] = useState<Rect>();

  const observer = useRef(
    new ResizeObserver((entries) => {
      for (const entry of entries) {
        // If the entry is display:inline the contentRect.width will be zero
        // let rect = entry.target.getBoundingClientRect();

        // usually a single one as we pass a single ref
        // @see `contentBoxSize` for later
        setBoxSize({
          ...(entry.contentRect.toJSON() as Omit<DOMRect, "toJson">),
          scrollWidth: entry.target.scrollWidth,
          scrollHeight: entry.target.scrollHeight,
          // rect,
          // widthOverflow: entry.target.scrollWidth > Math.round(entry.contentRect.width || rect.width),
          widthOverflow: entry.target.scrollWidth > Math.round(entry.contentRect.width),
        });
      }
    }),
  );

  useEffect(() => {
    const currentObserver = observer.current;
    const element = ref.current;

    if (element) currentObserver.observe(element);

    return () => {
      // if ref changes, don't listen to the previous ref
      if (element) currentObserver.unobserve(element);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(
    () => () => {
      // kill the observer instance on unmount;
      observer.current?.disconnect();
    },
    [],
  );

  return boxSize;
};

export { useResizeObserver };
